import { render, staticRenderFns } from "./EducationTableComponent.vue?vue&type=template&id=60d00645&scoped=true"
import script from "./EducationTableComponent.vue?vue&type=script&lang=ts"
export * from "./EducationTableComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d00645",
  null
  
)

export default component.exports